import { render, staticRenderFns } from "./dictionaryIsDashboardItem.vue?vue&type=template&id=3669d97f&scoped=true&"
import script from "./dictionaryIsDashboardItem.vue?vue&type=script&lang=js&"
export * from "./dictionaryIsDashboardItem.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryIsDashboardItem.vue?vue&type=style&index=0&id=3669d97f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3669d97f",
  null
  
)

export default component.exports